import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { LoaderService } from '../shared/providers/loader.service';

@Component({
  selector: 'app-no-access-page',
  templateUrl: './no-access-page.component.html',
  styleUrls: ['./no-access-page.component.css']
})
export class NoAccessPageComponent implements OnInit {
  OMExpiryDate: Date;
  propertyId: number;
  contentType: number = 0;
  constructor(private router: Router, private http: HttpClient, private _loaderService: LoaderService, protected activatedRoute: ActivatedRoute, private _userService: UserManagerService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["expiryDate"] != null && params["expiryDate"] != undefined) {
        let dateval = params["expiryDate"];
        this.OMExpiryDate = new Date(dateval);
      }
      if (params["propertyId"] != null && params["propertyId"] != undefined) {
        this.propertyId = params["propertyId"];
      }
    });
  }
  ngOnInit() {
    this.checkExpiry();
  }
  checkExpiry() {
    if (this.OMExpiryDate != null && this.OMExpiryDate != undefined) {
      if (this.OMExpiryDate >= new Date()) {
        this._userService.GetOMFilePath(this.propertyId).subscribe(res => {
          if (res != null) {
            let s3url = res;
            if (res != 'NO OM Attached') {
              window.location.href = s3url;
            }
            else {
              this.router.navigateByUrl('/propertylisting?request=buy');
            }
          }
        });
      }
      else {
        this.contentType = 1
      }
    }
  }
}
